import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from 'minimal-shared/utils';
import { styled } from '@mui/material/styles';
import { flagIconClasses } from './classes';

// ----------------------------------------------------------------------

export function FlagIcon(t0) {
  const $ = _c(10);
  let className;
  let code;
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      code,
      className,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = code;
    $[3] = other;
    $[4] = sx;
  } else {
    className = $[1];
    code = $[2];
    other = $[3];
    sx = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== code || $[7] !== other || $[8] !== sx) {
    t1 = code && <FlagRoot className={mergeClasses([flagIconClasses.root, className])} sx={[...(Array.isArray(sx) ? sx : [sx])]} {...other}><FlagImg alt={code} loading="lazy" className={flagIconClasses.img} src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${code?.toUpperCase()}.svg`} /></FlagRoot>;
    $[5] = className;
    $[6] = code;
    $[7] = other;
    $[8] = sx;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
const FlagRoot = styled('span')(({
  theme
}) => ({
  width: 26,
  height: 20,
  flexShrink: 0,
  display: 'grid',
  overflow: 'hidden',
  borderRadius: '5px',
  placeItems: 'center',
  backgroundColor: theme.vars.palette.background.neutral
}));
const FlagImg = styled('img')(() => ({
  width: '100%',
  height: '100%',
  maxWidth: 'unset',
  objectFit: 'cover'
}));